import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import _ from 'lodash';

export default class UserTaskAssignmentsDAO extends DAO {

  constructor(store) {
    super(store, 'user_task_assignment');
    this.unsetUserTaskAssignments = this.unsetUserTaskAssignments.bind(this);
    this.clearUserTaskAssignments = this.clearUserTaskAssignments.bind(this);
  }

  unsetUserTaskAssignments(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearUserTaskAssignments() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_user_task_assignments, options.toIgnore.userTaskAssignments, this.unsetUserTaskAssignments, this.clearUserTaskAssignments, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/UserTaskAssignmentsDAO.js